var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 8C0 12.4184 3.5816 16 8 16C12.4184 16 16 12.4184 16 8C16 3.5816 12.4184 0 8 0C3.5816 0 0 3.5816 0 8ZM14.4003 7.99896C14.4003 11.5336 11.5349 14.399 8.00026 14.399C4.46564 14.399 1.60026 11.5336 1.60026 7.99896C1.60026 4.46434 4.46564 1.59896 8.00026 1.59896C11.5349 1.59896 14.4003 4.46434 14.4003 7.99896ZM7.19987 10.401H8.79987V12.001H7.19987V10.401ZM8.80031 9.59989V9.08389C10.1152 8.69196 10.9526 7.40518 10.7784 6.04421C10.6042 4.68325 9.46976 3.64884 8.09853 3.6007C6.72731 3.55257 5.52309 4.50488 5.25391 5.85029L6.82351 6.16469C6.9474 5.54483 7.53091 5.12736 8.15757 5.21025C8.78424 5.29313 9.23915 5.84793 9.19764 6.47869C9.15613 7.10945 8.63243 7.59985 8.00031 7.59989C7.55848 7.59989 7.20031 7.95806 7.20031 8.39989V9.59989H8.80031Z",
    fill: "#757575"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default __webpack_public_path__ + "static/media/question.d15b587638013137668308c0e159b57f.svg";
export { ForwardRef as ReactComponent };